import axios from "axios";
import { API_BASE_URL, PROPERTIES_API } from "@/api-config";

const state = {
	items: [],
	amenities: [],
	adults: 0,
	children: [],
	results: {
		cities: [],
		states: [],
		countries: [],
		allOptions: [],
	},
	currentPage: 1,
	totalPages: 1,
	itemsResults: 0,
	paginationLinks: {
		first: null,
		last: null,
		prev: null,
		next: null,
		pages: [],
	},
	number: 0,
	error: {
		status: false,
		message: "",
	},
	nationality: "",
	guests: [],
	start_date: "",
	end_date: "",
};

const mutations = {
	SET_GUESTS(state, guests) {
		state.guests = guests;
	},

	SET_NATIONALITY(state, nationality) {
		state.nationality = nationality;
	},

	SET_CAPACITY(state, { adults, children }) {
		state.adults = adults;
		state.children = children;
	},
	SET_ERROR(state, error) {
		state.error = error;
	},
	SET_ITEMS(state, items) {
		state.items = items.items;
		state.amenities = items.amenities;
		state.paginationLinks = items.paginationLinks;
		state.totalPages = items.totalPages;
		state.currentPage = items.currentPage;
		state.itemsResults = items.itemsResults;
	},
};

const actions = {
	updateGuests({ commit }, guests) {
		commit("SET_GUESTS", guests);
	},

	updateNationality({ commit }, { nationality }) {
		commit("SET_NATIONALITY", nationality);
	},

	updateCapacity({ commit }, { adults, children }) {
		commit("SET_CAPACITY", { adults, children });
	},

	updateError({ commit }, error) {
		commit("SET_ERROR", error);
	},

	async fetchProperties({ commit, state }, queryParams) {
		let params = {
			start_date: queryParams.start_date,
			end_date: queryParams.end_date,
			city: queryParams.city,
			country: queryParams.country,
			rooms: queryParams.rooms,
			guests: queryParams.guests,
			property_id: queryParams.property_id,
			key: queryParams.key,
			page: queryParams.page == "undefined" ? 1 : queryParams.page,
		};

		if (queryParams.min_price !== "undefined") {
			params.min_price = queryParams.min_price;
		}

		if (queryParams.max_price !== "undefined") {
			params.max_price = queryParams.max_price;
		}

		if (queryParams.scores !== "undefined") {
			params.scores = queryParams.scores;
		}

		if (queryParams.reviews !== "undefined") {
			params.reviews = queryParams.reviews;
		}

		if (queryParams.amenities !== "undefined") {
			params.amenities = queryParams.amenities;
		}

		try {
			const URL = `${API_BASE_URL}${PROPERTIES_API}`;
			const response = await axios.get(URL, {
				params: params,
			});

			response.data.properties.links.shift();
			response.data.properties.links.pop();

			commit("SET_ITEMS", {
				items: response.data.properties.data,
				amenities: response.data.amenities,
				currentPage: response.data.current_page,
				totalPages: response.data.last_page,
				itemsResults: response.data.properties.total,

				paginationLinks: {
					first: response.data.properties.first_page_url,
					last: response.data.properties.last_page_url,
					prev: response.data.properties.prev_page_url,
					next: response.data.properties.next_page_url,
					pages: response.data.properties.links,
				},
			});

			return response.data;
		} catch (error) {
			commit("SET_ERROR", {
				status: true,
				message:
					error.response.status == 422
						? error.response.data.message
						: "Error en el servidor",
			});
		}
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
